import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormPercent, type FormPercentProps } from "../fields/FormPercent";
import type { FormComponentProps } from "../types";

export type FormPercentComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> & Omit<FormPercentProps<TFieldValues>, "control">;

export const FormPercentComponent = <TFieldValues extends FieldValues>(
	props: FormPercentComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormPercent control={control} {...restProps} />
		</FormComponent>
	);
};
